export default function PageHeader({ title, description, action }) {
  return (
    <div className="flex items-start justify-between gap-3 border-b border-black/5 pb-4">
      <div className="min-w-0">
        <h1 className="font-display text-3xl font-semibold text-accent md:text-4xl">{title}</h1>
        {description && <p className="mt-1 max-w-2xl text-sm leading-5 text-slate-500">{description}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
